import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

export const PrivateRoute = ({
  isAuthenticated,
  component: Component,
  ...rest
}) => (
  <Route
    {...rest}
    component={(props) => {
      return isAuthenticated ? (
        <div>
          <Component {...props} />
        </div>
      ) : (
        <Redirect to="/login" />
      );
    }}
  ></Route>
);

const mapStateToProps = (state) => ({
  isAuthenticated: !!state.auth.uid && !!state.auth.emailVerified,
});

export default connect(mapStateToProps)(PrivateRoute);
